/** Message the studio, standard look over its behavior half. */
import { MessageStudioView } from './MessageStudioView';
import { useMessageStudio, type MessageStudioInput } from './useMessageStudio';

export { MessageStudioView, useMessageStudio };

export function MessageStudio(props: MessageStudioInput) {
  return <MessageStudioView {...useMessageStudio(props)} />;
}
